import { useTranslations } from "use-intl";
import { AirplaneIcon, BuildingsIcon } from "@phosphor-icons/react";

import PageError from "./errors/PageError";

interface OfferNotAvailableErrorProps {
  variant: "flight" | "hotel";
}

export const OfferNotAvailableError = ({
  variant,
}: OfferNotAvailableErrorProps) => {
  const masterKey =
    variant === "flight" ? "flights.notAvailable" : "hotels.notAvailable";
  const Icon = variant === "flight" ? AirplaneIcon : BuildingsIcon;

  const t = useTranslations(masterKey);

  return (
    <PageError
      title={t("title")}
      subtitles={[t("description")]}
      back={{
        text: t("button"),
        options: {
          to: variant === "flight" ? "/flights/departure/list" : "/hotels/list",
        },
      }}
      icon={<Icon size={60} color="var(--color-text-interactive)" />}
    />
  );
};
